export function limparApelido(valor) {
    if (valor) {
        return valor.replace(/[^A-Za-záàâãéèêíïóôõöúçñ]/g, "").toUpperCase();
    }
    return '';
}